import { Control, Controller } from 'react-hook-form';
import { SetupIPAHeader } from '../../SetupIPA/elements/SetupIPAHeader';
import styles from '../SetupIPADadosDeConcorrencia.module.scss';
import { FormValues } from '../interfaces';
import { PMC_PRICE_MODE_OPTIONS } from '../utils/options';
import { OptionRadioGroup } from './OptionRadioGroup';

export const PmcPriceModeSection = ({ control }: { control: Control<FormValues> }) => (
  <div className={styles['setup-ipa__price-preference-competitor']}>
    <SetupIPAHeader title={PMC_PRICE_MODE_OPTIONS.title} subtitle={PMC_PRICE_MODE_OPTIONS.subtitle} />
    <Controller
      name="pmc_price_mode"
      control={control}
      render={({ field: { ref, ...field } }) => <OptionRadioGroup {...field} options={PMC_PRICE_MODE_OPTIONS.options} inputRef={ref} />}
    />
  </div>
);
